"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReadMoreParagraph = void 0;
const lit_1 = require("lit");
const decorators_js_1 = require("lit/decorators.js");
require("@/components/common/button/semantics/read-more-button");
require("@/components/common/text/text");
const disclosure_controller_1 = require("@/controllers/disclosure-controller");
const utils_1 = require("@/utils");
require("@/components/common/text/semantics/paragraph");
let ReadMoreParagraph = class ReadMoreParagraph extends lit_1.LitElement {
    constructor() {
        super(...arguments);
        this.content = '';
        this.maxLength = 100;
        this.expanded = false;
        this.contentId = (0, utils_1.uniqueId)('read-more-content');
        this.disclosure = new disclosure_controller_1.DisclosureController(this, {
            isOpen: () => this.expanded,
            setOpen: open => {
                this.expanded = open;
            },
            getTrigger: () => this.trigger ?? undefined,
        });
    }
    render() {
        const truncated = this.content.length > this.maxLength;
        const displayText = truncated && !this.expanded
            ? this.content.slice(0, this.maxLength).trimEnd() + '...'
            : this.content;
        return (0, lit_1.html) `
      <mm-paragraph>
        <mm-text id=${this.contentId}>${displayText}</mm-text>
        ${this.renderToggleButton(truncated)}
      </mm-paragraph>
    `;
    }
    renderToggleButton(truncated) {
        if (!truncated)
            return lit_1.nothing;
        return (0, lit_1.html) `
      <mm-read-more-button aria-controls=${this.contentId}></mm-read-more-button>
    `;
    }
};
ReadMoreParagraph.styles = (0, lit_1.css) `
    :host {
      display: block;
    }

    mm-read-more-button {
      margin: 0;
      margin-left: var(--space-1);
    }

    mm-text {
      display: inline;
    }
  `;
__decorate([
    (0, decorators_js_1.property)({ type: String })
], ReadMoreParagraph.prototype, "content", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: Number, attribute: 'max-length' })
], ReadMoreParagraph.prototype, "maxLength", void 0);
__decorate([
    (0, decorators_js_1.state)()
], ReadMoreParagraph.prototype, "expanded", void 0);
__decorate([
    (0, decorators_js_1.query)('mm-read-more-button')
], ReadMoreParagraph.prototype, "trigger", void 0);
ReadMoreParagraph = __decorate([
    (0, decorators_js_1.customElement)('mm-read-more-paragraph')
], ReadMoreParagraph);
exports.ReadMoreParagraph = ReadMoreParagraph;
//# sourceMappingURL=data:application/json;base64,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